<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="modal-header">
          <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">รหัสสินค้า:</label>
                  <span class="form-control-plaintext">{{
                    PruMaterialCode
                  }}</span>
                </div>
              </div>
              <!--<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า(SAP):</label>
                  <span class="form-control-plaintext">{{PruProductDesc_th}}</span>
                </div>
              </div>-->
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <input
                    type="text"
                    id="PruProductDesc_th2"
                    name="PruProductDesc_th2"
                    v-model="PruProductDesc_th2"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">แบรนด์สินค้า:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PruProductBrandId'"
                    :name="'PruProductBrandId'"
                    :select2-options="PruProductBrandIdOptions"
                    v-model="PruProductBrandId"
                    ref="PruProductBrandIdSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">หมวดหมู่:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PruProductGroupId'"
                    :name="'PruProductGroupId'"
                    :select2-options="PruProductGroupIdOptions"
                    v-model="PruProductGroupId"
                    @selectChange="PruProductGroupChange"
                    ref="PruProductGroupIdSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label-required">ประเภทสินค้า:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PruProductTypeId'"
                    :name="'PruProductTypeId'"
                    :select2-options="PruProductTypeIdOptions"
                    v-model="PruProductTypeId"
                    ref="PruProductTypeIdSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">หน่วยนับ:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PruUnitId'"
                    :name="'PruUnitId'"
                    :select2-options="PruUnitIdOptions"
                    v-model="PruUnitId"
                    ref="PruUnitIdSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ราคากลาง:</label>
                  <div class="row">
                    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8">
                      <currency-input 
                        class="form-control"
                        v-model="PruInitialPrice"
                        id="PruInitialPrice"
                        name="PruInitialPrice"
                        v-currency="{ locale, currency }"
                        auto-decimal-mode:true
                        placeholder="ราคากลาง"
                      />
                      <span class="form-text"></span>
                    </div>
                    <button
                      type="button"
                      class="btn m-btn--pill btn-info btn-block col-xl-2"
                      id="btnUsePruAvgPrice"
                      @click="onUsePruAvgPriceClick"
                    >
                      ใช้ราคาเฉลี่ย
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ราคาเฉลี่ย:</label>
                  <span class="form-control-plaintext">{{
                    PruAvgPrice | currency("฿", 2)
                  }}</span>
                </div>
              </div>
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">Quantity:</label>
                  <span class="form-control-plaintext">{{PruQty | currency('', 0)}}</span>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">Available Quantity:</label>
                  <span class="form-control-plaintext">{{PruAvQty | currency('', 0)}}</span>
                </div>
              </div> -->
            </div>

            <div class="row">
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6"
                v-if="
                  PruMaterialType == '3' ||
                    PruMaterialType == '6' ||
                    PruMaterialType == '27'
                "
              >
                <div class="form-group">
                  <label>หัวจ่าย:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PruIsBarButler"
                        name="PruIsBarButler"
                        v-model="PruIsBarButler"
                        type="checkbox"
                        class="form-check-input"
                      />
                      มีหัวจ่ายในตัว
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6"
                v-if="
                  (PruMaterialType == '3' && PruIsBarButler == true) ||
                    PruMaterialType == '6' ||
                    (PruMaterialType == '27' && PruIsBarButler == true)
                "
              >
                <div class="form-group">
                  <label class="label">จำนวนหัวจ่าย:</label>
                  <input
                    type="number"
                    id="PruBarButlerQty"
                    name="PruBarButlerQty"
                    v-model="PruBarButlerQty"
                    class="form-control"
                    min="0"
                    max="10000"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>รหัสบาร์โค้ด:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PruHasBarcode"
                        name="PruHasBarcode"
                        v-model="PruHasBarcode"
                        type="checkbox"
                        class="form-check-input"
                      />
                      มีข้อมูล BARCODE
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>สินค้าสำหรับใบHold(รับคืน):</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PruIsForJobHold"
                        name="PruIsForJobHold"
                        v-model="PruIsForJobHold"
                        type="checkbox"
                        class="form-check-input"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
                <!-- Begin:UseStockCoverDays element (CR-StockCoverDays A2 · ย้ายมาไว้ใต้ "สินค้าสำหรับใบHold") -->
                <div class="form-group">
                  <label>ใช้งาน Stock Cover Days:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PruUseStockCoverDays"
                        name="PruUseStockCoverDays"
                        v-model="PruUseStockCoverDays"
                        type="checkbox"
                        class="form-check-input"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
                <!-- End:UseStockCoverDays element -->
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                  <label class="label">ประเภทอะไหล่งาน PM:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PruPMSpare'"
                    :name="'PruPMSpare'"
                    :select2-options="PruPMSpareOptions"
                    v-model="PruPMSpare"
                    ref="PruPMSpareSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>

            <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="form-group">
                    <label>ตั้งค่าสินค้าสำหรับใช้งานช่างซ่อมบำรุง:</label>

                    <div class="form-check">
                        <label class="form-check-label kt-checkbox">
                            <input id="isSpareOrMachine"
                                   name="isSpareOrMachine"
                                   v-model="isSpareOrMachine"
                                   type="checkbox"
                                   class="form-check-input" 
                                   @change="onSpareOrMachineChange"
                                   />
                            ประเภทเครื่องเบียร์สด/อุปกรณ์ ใช้สำหรับใบงานประเมินสภาพและใบงานซ่อมอุปกรณ์เบียร์สด
                            <span></span>
                        </label>

                        <label class="text-danger" style="margin-left: 28px;">
                            *การเลือกประเภทมีผลต่อการแสดงแบบฟอร์มในใบงาน
                        </label>

                        <select2 class="form-control m-select2 QiSubProductTypeSelect"
                                 id="QiSubProductType"
                                 name="QiSubProductType"
                                 :select2-options="QiSubProductTypeOptions"
                                 v-model="QiSubProductType"
                                 @selectChange="onSubProductTypeChange(QiSubProductType)"
                                 ref="QiSubProductTypeSelect2"></select2>
                    </div>


                    <div class="form-check">
                        <label class="form-check-label kt-checkbox">
                            <input id="IsQiSpare"
                                   name="IsQiSpare"
                                   v-model="IsQiSpare"
                                   type="checkbox"
                                   class="form-check-input" />
                            อะไหล่ช่างซ่อมบำรุง
                            <span></span>
                        </label>
                    </div>

                    <div class="form-check">
                        <label class="form-check-label kt-checkbox">
                            <input id="IsSupplierSpare"
                                   name="IsSupplierSpare"
                                   v-model="IsSupplierSpare"
                                   type="checkbox"
                                   class="form-check-input" />
                            อะไหล่ซัพพลายเออร์
                            <span></span>
                        </label>
                    </div>

                </div>
                
              </div>
            </div>
            <!-- Begin:Picture element -->
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label
                    >รูปภาพ:<span
                      class="text-sm text-danger"
                      style="font-size:small"
                    >
                      (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน
                      10Mb.)</span
                    >
                  </label>
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                    @click="uploadFile"
                  >
                    <i class="flaticon-upload-1"></i>รูป
                  </button>
                  <div class="row" id="container-img">
                    <div
                      v-for="image in FileUpload"
                      :key="image.pictureId"
                      v-if="image.isLoaded"
                      class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                      :id="image.pictureId"
                    >
                      <img
                        :src="image.urlImg"
                        class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                        @error="handleImageError(image)"
                        @load="handleImageLoad(image)"
                      />
                      <a
                        href="javascript:;"
                        style="position:absolute;top:10px;right:20px;"
                        class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                        @click="removeImage(image.pictureId)"
                      >
                        <span class="m--font-inverse-danger la la-trash"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- End:Picture element -->

            <div class="row">
              <div class="col-xl-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="PruInActiveStatus"
                        name="PruInActiveStatus"
                        v-model="PruInActiveStatus"
                        type="checkbox"
                        class="form-check-input"
                      />
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- UseStockCoverDays checkbox ย้ายขึ้นไปไว้ใต้ "สินค้าสำหรับใบHold(รับคืน)" แล้ว -->

            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary" data-dismiss="modal">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";


export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      isChange: false,
      hocHolderTime: null,
      PruMaterialCode: null,
      PruProductDesc_th: null,
      PruProductDesc_th2: null,
      PruProductBrandDesc: null,
      PruProductTypeDesc: null,
      PruProductGroupDesc: null,
      PruProductBrandId: null,
      PruProductTypeId: null,
      PruProductGroupId: null,
      PruBaseUnit: null,
      PruUnitId: null,
      PruInActiveStatus: null,
      PruIsBarButler: null,
      PruBarButlerQty: null,
      PruMaterialType: null,
      FileUpload: [],
      locale: "th",
      currency: "THB",
      PruInitialPrice: null,
      PruAvgPrice: null,
      PruQty: null,
      PruAvQty: null,
      PruIsForJobHold: null,
      PruHasBarcode: null,
      PruUseStockCoverDays: false,
      PruPMSpare: null,
      QiSubProductTypeOptions:[],

      isSpareOrMachine: false,
      IsQiMachine : false,
      IsQiEquipment: false,

      IsQiSpare: false,
      IsSupplierSpare : false, 
      QiSubProductType : null,
      
      PruPMSpareOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทอะไหล่งาน PM",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PMSPARE_CODE",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      PruProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              InActiveStatus: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      PruUnitIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2ProductUnit",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      PruProductTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductType/Select2ProductTypeByGroup",
          data: function(params) {
            var query = {
              productGroupId: self.PruProductGroupId,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      
      PruProductGroupIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductGroup/Select2ProductGroup",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

        QiSubProductTypeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/QiJobs/Select2SubProductType",
          data: function(params) {
            var query = {
              search: "",
              page: 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

    };
  },
  methods: {
    handleImageError(image) {
      image.isLoaded = false;
      // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
    },
    handleImageLoad(image) {
      image.isLoaded = true;
      // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter(
            (img) => img.pictureId !== pictureId
          );
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", (event) => {
        const files = event.target.files;
        Array.from(files).forEach((file) => {
          if (
            ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
            file.size <= 10 * 1024 * 1024
          ) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true,
              };
              this.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert(
              "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
            );
          }
        });
      });
    },
    async formSubmit(e) {
      let router = this.$router;
      let self = this;

      if (self.PruProductBrandId == "" || self.PruProductBrandId == null) {
        this.PruProductBrandId = 1;
      }

      //if(self.isSpareOrMachine && !self.QiSubProductType){
      //    //alert('required SubProductType');
      //    return false;
     // }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let uploadedFiles = [];
      let isUploadFile = false;

      for (let file of this.FileUpload) {
        if (file.isNew && file.fileDataContext) {
          try {
            isUploadFile = true;
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterProduct");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
            });

            uploadedFiles.push({
              contentType: "-",
              downloadUrl: uploadResponse.data.fileUrl,
              fileInfoId: uploadResponse.data.fileInfoId,
              fileName: uploadResponse.data.fileInfoId,
              gridFsId: uploadResponse.data.gridFsId,
              sysName: "-",
            });
          } catch (error) {
            console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
          }
        } else if (!file.isNew) {
          uploadedFiles.push(file);
        }
      }

      const picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];

      axios
        .put("/Api/Product", {
          MaterialCode: this.$route.params.id,
          MaterialDesc_TH2: this.PruProductDesc_th2,
          ProductBrandId: this.PruProductBrandId,
          UnitId: this.PruUnitId,
          ProductGroupId: this.PruProductGroupId,
          ProductTypeId: this.PruProductTypeId,
          InitialPrice: this.PruInitialPrice,
          InActiveStatus: !this.PruInActiveStatus,
          IsForJobHold: this.PruIsForJobHold,
          HasBarcode: this.PruHasBarcode,
          IsBarButler: this.PruIsBarButler,
          BarButlerQty: this.PruBarButlerQty,
          UseStockCoverDays: this.PruUseStockCoverDays,
          PMSpareCode: this.PruPMSpare != "" ? this.PruPMSpare : null,
          Pictures: picturesData,
          IsQiSpare: this.IsQiSpare,
          IsQiMachine: this.IsQiMachine,
          IsQiEquipment:this.IsQiEquipment,
          IsSupplierSpare: this.IsSupplierSpare,
          QiSubProductType: this.QiSubProductType
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    PruProductGroupChange: function(id, text, data, ref) {
      if (this.isChange) {
        $("#PruProductTypeId")
          .val("")
          .trigger("change");
      }
    },
    onUsePruAvgPriceClick() {
      let self = this;
      self.PruInitialPrice = self.PruAvgPrice;
    },
    onSubProductTypeChange(selectedId) {
      //console.log("Selected ID:", selectedId)
      
      if(!selectedId){
        this.isSpareOrMachine = false; // unchecked when clear ddl.
        this.IsQiEquipment = false;
        this.IsQiMachine = false;
        return;
      }
      else{
        this.isSpareOrMachine = true;
        if (selectedId == "6") {
          this.IsQiMachine = true;
          this.IsQiEquipment = false;
        }else{
          this.IsQiMachine = false;
          this.IsQiEquipment = true;
        }
        

      }
      // ค้นหา object เต็มจาก options (ถ้าจำเป็น)
      //const selectedItem = this.QiSubProductTypeOptions.find(x => x.id === selectedId)
      
      //if (selectedItem) {
      //  this.isSpareOrMachine = true;
      //}
      },
      onSpareOrMachineChange() {
          
          if (!this.isSpareOrMachine) {
              this.QiSubProductType = null;  

              $("#QiSubProductType")
                  .val("")
                  .trigger("change");   // Reset to unselected

          }
      }
  },
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Product/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.PruMaterialCode = response.data.materialCode;
          self.PruProductDesc_th = response.data.materialDesc_th;
          self.PruProductDesc_th2 = response.data.materialDesc_th2;
          self.PruProductBrandId = response.data.materialBrand;
          self.PruProductBrandDesc = response.data.materialBrandDesc;
          self.PruUnitId = response.data.unitId;
          self.PruBaseUnit = response.data.baseUnit;
          self.PruInActiveStatus = !response.data.inActiveStatus;
          self.PruInitialPrice = response.data.initialPrice;
          self.PruAvgPrice = response.data.avgPrice;
          self.PruQty = response.data.qty;
          self.PruAvQty = response.data.availableQty;
          self.PruIsForJobHold = response.data.isForJobHold;
          self.PruHasBarcode = response.data.hasBarcode;
          self.PruUseStockCoverDays = response.data.useStockCoverDays;
          self.PruMaterialType = response.data.materialType;
          self.PruIsBarButler = response.data.isBarButler;
          self.PruBarButlerQty = response.data.barButlerQty;

          self.IsQiSpare = response.data.isQiSpare;
          self.IsQiMachine = response.data.isQiMachine;
          self.IsQiEquipment = response.data.isQiEquipment;
          self.IsSupplierSpare = response.data.isSupplierSpare; 
          self.QiSubProductType = response.data.qiSubProductType;

          if(self.IsQiEquipment || self.IsQiMachine)
            self.isSpareOrMachine = true;
          else
            self.isSpareOrMachine = false;


          console.log("IsQiEquipment:", self.IsQiEquipment)
          console.log("IsQiMachine:", self.IsQiMachine)
          console.log("Result:", self.IsQiEquipment || self.IsQiMachine)


          if (response.data.materialBrand && response.data.materialBrandDesc != " ") {
            self.$refs.PruProductBrandIdSelect2.setSelectedData({
              id: response.data.materialBrand,
              text: response.data.materialBrandDesc,
            });
          }

          if (response.data.baseUnit) {
            self.$refs.PruUnitIdSelect2.setSelectedData({
              id: response.data.unitId,
              text: response.data.baseUnit,
            });
          }

          if (response.data.materialGrp) {
            self.$refs.PruProductGroupIdSelect2.setSelectedData({
              id: response.data.materialGrp,
              text: response.data.materialGrpDesc,
            });
          }

          if (response.data.materialType) {
            self.$refs.PruProductTypeIdSelect2.setSelectedData({
              id: response.data.materialType,
              text: response.data.materialTypeDesc,
            });
          }

          if (response.data.materialGrp) {
            self.$refs.PruPMSpareSelect2.setSelectedData({
              id: response.data.pmSpareCode,
              text: response.data.pmSpareName,
            });
          }

          if (response.data.qiSubProductType) {
            self.$refs.QiSubProductTypeSelect2.setSelectedData({
              id: response.data.qiSubProductType,
              text: response.data.qiSubProductTypeDesc
            });
          } 

          self.FileUpload = response.data.pictures.map((element) => ({
            pictureId: element.pictureId,
            fileName: element.fileName,
            fileInfoId: element.fileInfoId,
            downloadUrl: element.downloadUrl,
            urlImg: element.urlImg,
            gridFsId: element.gridFsId,
            sysName: element.sysName,
            isNew: false,
            isLoaded: true,
          }));

        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        self.isChange = true;
        KTApp.unblockPage();
      });

    $(this.$refs.form).validate({
      rules: {
        PruProductTypeId: "required",
        PruProductGroupId: "required",
        QiSubProductType: {
          required: function () {
            return self.isSpareOrMachine === true;
          }
        }
      },
      messages: {
        PruProductTypeId: "กรุณาเลือกประเภทสินค้า",
        PruProductGroupId: "กรุณาเลือกหมวดหมู่สินค้า",
        QiSubProductType: "ประเภทเครื่องเบียร์สด/อุปกรณ์"
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>
<style>
    .QiSubProductTypeSelect + .select2-container {
        margin-left: 28px !important;
        width: 60% !important;
    }
    .QiSubProductTypeSelect {
        display: none !important;
    }


</style>


// WEBPACK FOOTER //
// App/Components/Master/Product/ProductUpdate.vue